// Profundidade de scroll e tempo visível por rota.
// - Marca atinge nos buckets 25/50/75/100% (1x cada por rota).
// - Loga 'scroll_depth' quando bucket é atingido.
// - Loga 'route_time' quando o usuário sai da rota (mudança de pathname / hide).
//
// Não usa IntersectionObserver porque a granularidade que queremos é
// percentual da página inteira, não de um elemento específico.

import { logUxEvent } from './uxLogger';

const BUCKETS = [25, 50, 75, 100];

let currentRoute = null;
let routeEnteredAt = 0;
let routeMaxDepth = 0;
let routeBucketsHit = new Set();

const computeDepthPct = () => {
  const doc = document.documentElement || document.body;
  const scrollTop = window.scrollY || window.pageYOffset || 0;
  const viewport = window.innerHeight || 0;
  const total = Math.max(doc.scrollHeight || 0, viewport + scrollTop);
  if (total <= viewport) return 100;
  const reached = scrollTop + viewport;
  return Math.min(100, Math.round((reached / total) * 100));
};

const onScroll = () => {
  const pct = computeDepthPct();
  if (pct > routeMaxDepth) routeMaxDepth = pct;
  for (const b of BUCKETS) {
    if (pct >= b && !routeBucketsHit.has(b)) {
      routeBucketsHit.add(b);
      logUxEvent('scroll_depth', { route: currentRoute, depth: b });
    }
  }
};

const flushRoute = () => {
  if (!currentRoute) return;
  const duration = Date.now() - routeEnteredAt;
  if (duration > 500) {
    logUxEvent('route_time', {
      route: currentRoute,
      duration_ms: duration,
      max_depth: routeMaxDepth,
    });
  }
};

const enterRoute = (route) => {
  flushRoute();
  currentRoute = route;
  routeEnteredAt = Date.now();
  routeMaxDepth = 0;
  routeBucketsHit = new Set();
  // Computa imediatamente: rotas curtas já estão 100% visíveis.
  setTimeout(onScroll, 0);
};

let initialized = false;
let lastPathname = null;

const checkRouteChange = () => {
  const path = window.location.pathname;
  if (path !== lastPathname) {
    lastPathname = path;
    enterRoute(path);
  }
};

export const initScrollDepth = () => {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  lastPathname = window.location.pathname;
  enterRoute(lastPathname);

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // React Router v7 não dispara 'popstate' em pushState — precisamos polar.
  setInterval(checkRouteChange, 800);
  window.addEventListener('popstate', checkRouteChange);

  // Flush no fim da sessão.
  window.addEventListener('pagehide', flushRoute);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flushRoute();
  });
};
